<template>
  <div class="circular-loading-bar-container">
    <svg class="circular-loading-bar" :width="64" :height="64" viewBox="0 0 36 36">
      <path
        class="circle-bg"
        d="M18 2.0845
           a 15.9155 15.9155 0 0 1 0 31.831
           a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#e0e0e0"
        stroke-width="0.5"
      />
      <path
        class="circle"
        :d="circlePath"
        fill="none"
        stroke="#4D84FF"
        stroke-width="1"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
        stroke-linecap="round"
      />
    </svg>
    <img class="center-image" :src="iconImgPath" alt="Center Image">
  </div>
</template>

<script>
import inventoryIcon from '@/images/cover-cards/inventory.svg'
import shippingTruckIcon from '@/images/cover-cards/shipping-truck.svg'
import dealTagIcon from '@/images/cover-cards/deal-tag.svg'

export default {
  props: {
    duration: {
      type: Number,
      required: true,
      default: 20000 // 20 seconds
    },
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      progress: 0,
      circumference: 100,
      inventory: inventoryIcon,
      shippingTruck: shippingTruckIcon,
      dealTag: dealTagIcon
    }
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference
    },
    circlePath() {
      return `M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831`
    },
    iconImgPath () {
      switch (this.icon) {
      case 'inventory':
        return this.inventory
      case 'shipping-truck':
        return this.shippingTruck
      case 'deal-tag':
        return this.dealTag
      default:
        return ''
      }
    }
  },
  mounted() {
    this.circumference = 2 * Math.PI * 15.9155
    this.startLoading()
  },
  methods: {
    startLoading() {
      const intervalDuration = (this.duration / 100) * 10
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 1
        } else {
          clearInterval(interval)
        }
      }, intervalDuration)
    }
  }
}
</script>

<style scoped>
.circular-loading-bar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 64px;
  width: 64px;
}

.circular-loading-bar {
  transform: rotate(0deg);
  position: absolute;
}

.center-image {
  height: 24px;
  width: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: invert(53%) sepia(61%) saturate(4317%) hue-rotate(205deg) brightness(101%) contrast(101%);
}

.circle {
  transition: stroke-dashoffset 0.3s linear;
}
</style>
